import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

interface Herbicide {
  id: string
  herbicide_name: string
  herbicide_dose: number
  supplier: string
  registration_number: string
}

export interface HerbicideTreatment {
  id: string
  treatment_name: string
  treatment_cost: number
  herbicides: Herbicide[]
}

export async function getHerbicideTreatments(options?: AxiosRequestConfig) {
  const { data } = await companiesApi.get<HerbicideTreatment[]>(
    apiRoutes.getHerbicideTreatments,
    options,
  )

  return data
}
